import React from 'react';
import TimePicker from 'material-ui/TimePicker';
import DatePicker from 'material-ui/DatePicker';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import { adjustTime } from '../../lib/utils';

class TimePickerDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...this.getTimeRange(props),
            open: props.open,
        }
    }

    getTimeRange(props) {
        return {
            start: this.toDateTime(props.start),
            end: this.toDateTime(props.end)
        }
    }

    toDateTime(date){
        return {
            date: new Date(date.getTime()),
            time: new Date(date.getTime())
        }
    }

    setStartDate(date) {
        this.setState({...this.state, start: {date: date, time: this.state.start.time}});
    }

    setStartTime(time) {
        this.setState({...this.state, start: {date: this.state.start.date, time: time}});
    }

    setEndDate(date) {
        this.setState({...this.state, end: {date: date, time: this.state.end.time}});
    }

    setEndTime(time) {
        this.setState({...this.state, end: {date: this.state.end.date, time: time}});
    }

    handleClose() {
        this.props.handleClose({
                start: adjustTime(this.state.start.date, this.state.start.time),
                end: adjustTime(this.state.end.date, this.state.end.time),
            });
    };

    handleCancel() {
        this.props.handleClose(null);
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            ...this.getTimeRange(nextProps),
            open: nextProps.open,
        });
    }

    render() {
        const actions = [
            <FlatButton
                label="Cancel"
                primary={true}
                keyboardFocused={false}
                onTouchTap={()=>{this.handleCancel()}}
            />,
            <FlatButton
                label="Synchronize"
                primary={true}
                keyboardFocused={true}
                onTouchTap={()=>{this.handleClose()}}
            />
        ];

        return (
            <Dialog
                title="Synchronize between the following dates"
                modal={true}
                actions={actions}
                open={this.state.open}>
                    <div>
                        <DatePicker ref="startDate"
                                    value={this.state.start.date}
                                    hintText="From date"
                                    style={{width: '100px', display: 'inline-block'}}
                                    name="fromDate" autoOk={true}
                                    onChange={(n, date)=>{
                                        this.setStartDate(date);
                                        this.refs.startTime.openDialog()
                                    }}/>
                        <TimePicker ref="startTime" value={this.state.start.time}
                                    hintText="From time" style={{width: '100px', display: 'inline-block'}}
                                    name="fromTime" autoOk={true} format="24hr"
                                    onChange={(n, time)=>{
                                        this.setStartTime(time);
                                    }}/>
                    </div>
                    <div>
                        <DatePicker ref="endDate" value={this.state.end.date}
                                    hintText="End date"  style={{width: '100px', display: 'inline-block'}}
                                    name="toDate" autoOk={true}
                                    onChange={(n, date)=>{
                                        this.setEndDate(date);
                                        this.refs.endTime.openDialog()
                                    }}/>
                        <TimePicker ref="endTime" value={this.state.end.time}
                                    hintText="End time" style={{width: '100px', display: 'inline-block'}}
                                    name="toTime" autoOk={true} format="24hr"
                                    onChange={(n, time)=>{
                                        this.setEndTime(time);
                                    }}/>
                    </div>
            </Dialog>
        )
    }
}
export default TimePickerDialog;



// WEBPACK FOOTER //
// ./src/components/dialog/TimePickerDialog.js